module.exports = __webpack_public_path__ + "087179c87656d42c04b8b2d5c268d5c6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/AR.svg
// module id = U1hd
// module chunks = 0